var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/metadatas/values.ts
var metadataConfiguration = {
  translationVersion: "b45a37afc775116bc433003a0557b01df9c7a784",
  referenceDataVersion: "b45a37afc775116bc433003a0557b01df9c7a784"
};

// src/metadatas/hard-limits.config.ts
var HARD_LIMITS = {
  accessControlList: {
    userGroupNameMaxSize: 256,
    userGroupsMaxCount: 256,
    companyGroupNameMaxSize: 256,
    companyGroupsMaxCount: 256,
    roleNameMaxSize: 256,
    rolesMaxCount: 256
  },
  userProfile: {
    firstnameMaxSize: 256,
    lastnameMaxSize: 256,
    avatarMaxSize: 10 * 1024 * 1024
  },
  lists: {
    maxEntriesPerPage: 500,
    minEntriesPerPage: -1,
    searchValueMaxSize: 256
  },
  comments: {
    commentMaxSize: 8192,
    attachmentMaxSize: 64 * 1024 * 1024,
    attachmentsCountMax: 1
  },
  misc: {
    postBodyMaxSize: 1024 * 1024 * 5
  },
  reports: {
    controlResultSelectLimit: 1e5
  }
};

// src/uploads/index.ts
var IMAGE_CONTENT_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png"
];
var TEXT_CONTENT_TYPES = [
  "text/csv",
  "text/plain"
];
var BINARY_CONTENT_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
  "application/msword",
  "application/vnd.ms-excel"
];
var COMMENT_ATTACHMENT_ALLOWED_CONTENT_TYPES = [
  ...IMAGE_CONTENT_TYPES,
  ...TEXT_CONTENT_TYPES,
  ...BINARY_CONTENT_TYPES
];
var PROFILE_PICTURE_ALLOWED_CONTENT_TYPES = IMAGE_CONTENT_TYPES;

// src/datas/index.ts
var LEGACY_ID_WITH_MOCKED_STATS = [
  11801,
  12231,
  13451,
  13552,
  13544,
  13618
];

// src/bigquery/index.ts
var BIGQUERY_CI_DATASET = "cds_6a692ece_d3a7_4306_b032_34038f84e16e";
var BIGQUERY_CI_PROJECT_ID = "supervizor-review-europe";

// src/emails/titles.ts
var titles = {
  "user-mentioned": {
    en: "You were mentioned in a comment",
    fr: "Vous avez \xE9t\xE9 mentionn\xE9 dans un commentaire"
  },
  "analysis-report-ready": {
    en: "Your Excel file is ready",
    fr: "Votre fichier Excel est pr\xEAt"
  },
  "analysis-report-generation-failed": {
    en: "Oops! Excel export failed",
    fr: "Oups! L'export Excel a \xE9chou\xE9"
  }
};

// src/emails/index.ts
var email = {
  titles
};

// src/logging/index.ts
var logging = {
  MaxLogSqlQuerySize: 5e3
};

// src/i18n/config.ts
var supportedLngs = [
  "fr_FR",
  "en_US"
];
var initConfig = {
  defaultLng: "en_US",
  initOptions: {
    lng: "en_US",
    supportedLngs,
    fallbackLng: "en_US",
    preload: supportedLngs
  }
};
var createI18nHttpBackendConfig = /* @__PURE__ */ __name((baseUrl) => {
  const url = new URL(`translations/${metadataConfiguration.translationVersion}`, baseUrl);
  return {
    loadPath: `${url.toString()}/{{lng}}.json`
  };
}, "createI18nHttpBackendConfig");

// src/i18n/index.ts
var translation = {
  config: initConfig,
  createI18nHttpBackendConfig
};

// src/datadog/events/index.ts
var ANALYSIS_REQUEST_REGISTERED = "analysis_report_generation_registered";
var ANALYSIS_REPORT_REQUEST_DENIED = "analysis_report_generation_denied";
var ANALYSIS_REPORT_REQUEST_ERROR = "analysis_report_generation_error";

// src/reports/index.ts
var reportsConfig = {
  reportRetentionDays: 90,
  reportRetentionMs: 90 * 24 * 3600 * 1e3
};
export {
  ANALYSIS_REPORT_REQUEST_DENIED,
  ANALYSIS_REPORT_REQUEST_ERROR,
  ANALYSIS_REQUEST_REGISTERED,
  BIGQUERY_CI_DATASET,
  BIGQUERY_CI_PROJECT_ID,
  COMMENT_ATTACHMENT_ALLOWED_CONTENT_TYPES,
  HARD_LIMITS,
  LEGACY_ID_WITH_MOCKED_STATS,
  PROFILE_PICTURE_ALLOWED_CONTENT_TYPES,
  email,
  logging,
  metadataConfiguration,
  reportsConfig,
  translation
};
//# sourceMappingURL=index.js.map